<template>
  <div class="editable-cell">
    <div v-if="status!=='1' || String(text) === '0'" class="editable-cell-input-wrapper">
      <a-input-number
        :style="status==='2' ? 'border: 1px solid #1890ff' : status==='0' ? 'border: 1px solid red' : ''"
        v-model="value"
        :min="0"
        :max="30"
        :precision="2"
        @change="handleChange"
      />
    </div>
    <div class="editable-cell-text-wrapper">
      <a-popover placement="leftTop" overlayClassName="resetPopover resetSuccessPopover" v-if="status === '1' && String(text) !== '0'">
        <!--提交校验成功-->
        <template slot="content">
          <span style="background-color: #52c41a">已通过审核，已经不可修改</span>
        </template>
        <a-badge :count="value + ' h'" :numberStyle="{backgroundColor: '#52c41a','border-radius':'0'} " :showZero="true"/>
      </a-popover>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: [Number, String], // 在handleChange的时候监听，输入小数点时例如‘2.’，此时text是个字符串
      default: 0.00
    },
    status: {
      type: String,
      default: '-1'
    }
  },
  data () {
    return {
      value: 0.00
    }
  },
  created () {
    this.initInput(this.text)
  },
  methods: {
    initInput (parentData) {
      if (parentData !== -1) {
        this.value = parentData
      }
    },
    handleChange (value) {
      if (!value) {
        value = 0.00
      }
      this.value = value
      this.$emit('change', this.value)
    }
  }
}
</script>
<style lang="less" scoped>
  .editable-cell {
    position: relative;
  }

  .editable-cell-icon,
  .editable-cell-icon-check {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    margin-left: 10px;
    cursor: pointer;
  }

  .editable-cell-icon {
    display: none;
  }

  .editable-cell:hover .editable-cell-icon {
    display: inline-block;
  }

  .editable-cell-icon:hover,
  .editable-cell-icon-check:hover {
    color: #108ee9;
  }
</style>
<style lang="less">
  .resetPopover{
    .ant-popover-inner-content{
      padding: 0;
      color: #fff;
      span{
        display: block;
        padding: 12px 16px;
      }
    }
  }
  .resetSuccessPopover{
    .ant-popover-content{
      .ant-popover-arrow{
        border-top-color: #52c41a;
        border-right-color: #52c41a;
      }
    }
  }
  .resetFailPopover{
    .ant-popover-content{
      .ant-popover-arrow{
        border-top-color: #f4333c;
        border-right-color: #f4333c;
      }
    }
  }
  .resetUnsubmitPopover{
    .ant-popover-content{
      .ant-popover-arrow{
        border-top-color: #108ee9;
        border-right-color: #108ee9;
      }
    }
  }
</style>
